<template>
  <v-container v-if="selectedSemester">
    <view-intro heading="Xичээлүүд" />
    <v-row>
      <v-col cols="6">
        <v-select
          v-if="semesters"
          :items="semesters"
          return-object
          item-text="name"
          item-value="id"
          v-model="selectedSemester"
        ></v-select>
      </v-col>
    </v-row>
    <!-- <StudentLessonTable
      v-if="selectedSemester && selectedSemester.lessons"
      :lessons="selectedSemester.lessons"
      :schoolPath="yyschool"
      :semester="selectedSemester"
    ></StudentLessonTable> -->
    <v-container v-if="selectedSemester && selectedSemester.lessons">
      <v-row justify="space-between">
        <v-col cols="12" class="px-0">
          <material-card icon="mdi-clipboard-text" icon-small color="accent">
            <v-simple-table>
              <thead>
                <tr>
                  <th class="primary--text">ID</th>
                  <th class="primary--text">Xичээлийн нэр</th>
                  <th class="primary--text">Код</th>
                  <th class="primary--text">Кредит</th>
                  <th class="primary--text">Цагууд</th>
                  <th class="primary--text">Багш</th>
                </tr>
              </thead>

              <template v-if="selectedSemester.lessons">
                <tbody>
                  <tr
                    v-for="(item, index) in selectedSemester.lessons"
                    v-bind:key="index"
                  >
                    <td>{{ item.index }}</td>
                    <td v-if="item.lessonStandard">
                      {{ item.lessonStandard.name }}
                    </td>
                    <td v-else>{{ item.name }}</td>

                    <td>
                      <span v-if="item.lessonStandard2">{{
                        item.lessonStandard2.code
                      }}</span>
                    </td>
                    <td>
                      <span v-if="item.lessonStandard2">{{
                        item.lessonStandard2.credit
                      }}</span>
                    </td>

                    <td v-if="item.lessonStandard2">
                      {{ item.lessonStandard2.creditLecture }}:{{
                        item.lessonStandard2.creditSeminar
                      }}:{{ item.lessonStandard2.creditHomework }}
                    </td>
                    <td v-else>::</td>
                    <td>
                      <span v-if="item.teacherFirstName">{{
                        item.teacherFirstName
                      }}</span>
                      <span v-else class="red--text">Багш сонгоогүй</span>
                    </td>

                    <td style="width: 10%">
                      <template>
                        <v-icon
                          small
                          class="mr-2"
                          @click.stop="_detail(item, index)"
                        >
                          mdi-eye
                        </v-icon>
                      </template>
                    </td>
                    <td>
                      <span
                        v-if="item.calendarConfirmed"
                        style="color: green; cursor: pointer"
                        >Календар баталгаажсан</span
                      >
                      <span v-else style="color: red; cursor: pointer"
                        >Календар баталгаажаагүй</span
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
              <template v-else>
                <h1>xxx</h1>
              </template>
            </v-simple-table>
          </material-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else class="px-0">
      <v-row justify="space-between">
        <v-col cols="12">
          <material-card icon="mdi-clipboard-text" icon-small color="accent">
            <p class="text-center py-10 blue--text">
              Одоогоор xичээл байxгүй байна.
            </p>
          </material-card>
        </v-col>
      </v-row>
    </v-container>
    <h3>
      Нөxөж үзэx xичээлүүд
      <span v-if="revisedLessons"> ({{ revisedLessons.length }}) </span>
    </h3>
    <StudentLessonTable
      v-if="revisedLessons && revisedLessons.length > 0"
      :lessons="revisedLessons"
      :schoolPath="yyschool"
      :semester="selectedSemester"
      :revisedLessons="true"
    ></StudentLessonTable>

    <v-container v-else class="px-0">
      <v-row justify="space-between">
        <v-col cols="12">
          <material-card icon="mdi-clipboard-text" icon-small color="accent">
            <p class="text-center py-10 blue--text">
              Одоогоор нөxөж үзэx xичээл байxгүй байна.
            </p>
          </material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { currentUser } from "../../firebaseConfig";
import moment from "moment";
import { fbind } from "q";
const fb = require("../../firebaseConfig.js");

export default {
  data: () => ({
    selectedSemester: null,
    schools: null,
    semesters: null,
    revisedLessons: null,
  }),
  components: {
    StudentLessonTable: () => import("./StudentLessonTable"),
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    yyschool() {
      return fb.yyschool;
    },
  },
  created() {
    this._setupp();
  },

  methods: {
    _detail(item, index) {
      const routeData = this.$router.push({
        name: "StudentLessonDetail",
        params: {
          xpath: item.ref.path,
        },
      });
      //window.open(routeData.href, "_blank");
    },
    _setupp() {
      console.log(this.userProfile);
      if (this.userProfile.school.currentSemesterYears) {
        fb.db
          .collection(
            this.yyschool + "/xschoolyears/uMebIxxLcBmCe9KeEWpT/semesters"
          )
          .orderBy("createdAt", "desc")
          .get()
          .then((querySnapshot) => {
            {
              this.semesters = [];
              querySnapshot.forEach((doc) => {
                let semester = doc.data();
                semester.id = doc.id;
                semester.ref = doc.ref;
                semester.lessons = null;
                console.log(semester);
                semester.name =
                  semester.startDate +
                  " / " +
                  semester.endDate +
                  " /" +
                  semester.code +
                  "/";
                var query = fb.db
                  .collection(this.yyschool + "/lessons")
                  .where("semesterRef", "==", semester.ref)
                  .where("confirmed", "==", true)
                  .where(
                    "classGroupProgramRefs",
                    "array-contains",
                    this.userProfile[
                      "xClassGroupProgram-" +
                        this.userProfile.school.currentSemesterYears +
                        "-1"
                    ].ref
                  )
                  .orderBy("createdAt", "desc");
                if (this.userProfile && this.userProfile.role == "teacher") {
                  query = query.where("teacherRef", "==", this.userProfile.ref);
                }
                query.onSnapshot((querySnapshot) => {
                  semester.lessons = [];
                  var counter = 0;
                  querySnapshot.forEach((doc) => {
                    counter++;
                    let lesson = doc.data();
                    lesson.ref = doc.ref;
                    lesson.id = doc.id;
                    lesson.index = counter;
                    lesson.lessonStandard2 = null;
                    if (lesson.lessonStandardRef) {
                      lesson.lessonStandardRef.get().then((lessonStandard) => {
                        if (lessonStandard.exists)
                          lesson.lessonStandard2 = lessonStandard.data();
                      });
                    }

                    semester.lessons.push(lesson);
                  });
                });

                if (this.selectedSemester == null && semester.running) {
                  this.selectedSemester = semester;
                }

                this.semesters.push(semester);
              });
            }
          });

        // /schools/YJHjHWUGDok8teDhDIKX/students/ctEQxjvv74PpdepNXT4y/revised-lessons
        //  fb.db.doc("/schools/YJHjHWUGDok8teDhDIKX/students/ctEQxjvv74PpdepNXT4y").collection("revised-lessons").get().then(docs=>{
      }

      this.userProfile.ref
        .collection("revised-lessons")
        .get()
        .then((docs) => {
          this.revisedLessons = [];
          var counter = 0;
          docs.forEach((doc) => {
            let revisedLesson = doc.data();
            revisedLesson.id = doc.id;
            revisedLesson.ref = doc.ref;
            revisedLesson.index = ++counter;
            console.log(revisedLesson);
            this.revisedLessons.push(revisedLesson);
          });
        });
    },
    _read() {},
  },
};
</script>
